import GeologicBodyOperation from './GeologicBodyOperation.vue';
export default GeologicBodyOperation;
